import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=f9f48798"
import script from "./LogoCard.vue?vue&type=script&lang=js"
export * from "./LogoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports